import React, { createContext, useState, useContext, useEffect } from 'react';

const EnvContext = createContext();

export const EnvProvider = ({ children }) => {
    // Initialize state from localStorage, falling back to 'dev' if not found
    const [env, setEnv] = useState(null);
    const [isLoaded, setIsLoaded] = useState(true);

     useEffect(() => {
        // Function to determine environment
        const determineEnvironment = () => {
        const hostname = window.location.hostname;
        const isLocalhost = hostname === 'localhost' || hostname.includes('127.0.0.1');
        
        // Log the hostname for debugging
        console.log('Current hostname:', hostname);
        
        // Check if URL is prod or dev
        const isProd = hostname.includes('llmaas-operations-ui') ||
                        (!isLocalhost && !hostname.includes('llmaas-data-ui-dev') && !hostname.includes('llmaas-operations-ui-tst'));
        
        // Set environment based on hostname
        const detectedEnv = isProd ? 'prod' : 'dev';
        console.log('Detected environment:', detectedEnv);
        
        setEnv(detectedEnv);
        };

        determineEnvironment();
    }, []);

    // Save to localStorage whenever env changes
    // useEffect(() => {
    //     localStorage.setItem('env', env);
    // }, [env]);

    // const toggleEnv = () => {
    //     setIsLoaded(false);
    //     setEnv((prevEnv) => (prevEnv === 'dev' ? 'prod' : 'dev'));
    // };

    return (
        <EnvContext.Provider value={{ env, setEnv, isLoaded, setIsLoaded }}>
            {children}
        </EnvContext.Provider>
    );
};

export const useEnv = () => useContext(EnvContext);